/** Item stepper: `[-] 3 [+]`. Two real buttons, each naming what it changes for screen readers. */

import './chrome.css';
import { button, el } from '../dom';

export interface Stepper {
  readonly el: HTMLElement;
  readonly minus: HTMLButtonElement;
  readonly plus: HTMLButtonElement;
  /** `blockedWhy` explains a disabled plus (over weight, out of RP) as its tooltip. */
  set(count: number, canRemove: boolean, canAdd: boolean, blockedWhy?: string): void;
}

/** `what` reads as "GRENADES IN POD A": it completes "ADD ONE ..." / "REMOVE ONE ...". */
export function stepper(what: string, onStep: (delta: 1 | -1) => void): Stepper {
  const root = el('div', 'menu-stepper');
  const minus = button('-', () => onStep(-1), 'menu-btn-small menu-step');
  const plus = button('+', () => onStep(1), 'menu-btn-small menu-step');
  minus.setAttribute('aria-label', `REMOVE ONE ${what}`);
  plus.setAttribute('aria-label', `ADD ONE ${what}`);
  const count = el('span', 'menu-step-count', '0');
  root.append(minus, count, plus);
  return {
    el: root,
    minus,
    plus,
    set(value, canRemove, canAdd, blockedWhy = ''): void {
      count.textContent = String(value);
      count.classList.toggle('menu-step-zero', value === 0);
      setEnabled(minus, canRemove);
      setEnabled(plus, canAdd);
      plus.title = canAdd ? '' : blockedWhy;
    },
  };
}

/**
 * `aria-disabled` rather than `disabled`: a button that disables itself under the player's
 * finger would throw keyboard focus away mid-edit. The click handler's owner re-checks limits.
 */
function setEnabled(node: HTMLButtonElement, enabled: boolean): void {
  node.setAttribute('aria-disabled', enabled ? 'false' : 'true');
  node.classList.toggle('menu-step-off', !enabled);
}
